<template>
  <div class="subpage-title" v-if="subpageTittle">
    <!-- 额外设置子页面标题需要手动修改：label_manage -->
    <span class="title">{{ subpageTittle }}</span>
    <span class="desc">{{ subpageDese }}</span>
  </div>
</template>
<script>
export default {
  name: "subpageTitle",
  props: {
    subpageTittle: {
      type: String,
      default: "子页面标题",
    },
    subpageDese: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted: function () {
    let _this = this;
    _this.init();
  },
  updated: function () {},
  watch: {},
  methods: {
    init() {
      let _this = this;
    },
  },
};
</script>
  
<style lang="scss" scoped>
.subpage-title {
  padding: 0 0 24px 0;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin: 0 15px 0 0;
  }
  .desc {
    color: #666;
  }
}
</style>
  